import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
var propertyAlertWrapper = flow(withMedia, withAllhomesContext('isSignedIn', 'openSignIn', 'createPropertyAlert', 'removePropertyAlert', 'isIdentityLoaded'));
export default propertyAlertWrapper;